import { createContext } from 'react';
import { Evaluation } from 'src/models/evaluation';
import { Topic } from 'src/models/topic';

export interface EvaluationContextType {
  evaluations: Evaluation[];
  loading: boolean;
  fetchMyEvaluations: () => Promise<void>;
  updateItemEvaluation: (skillId: string, topicId: string, isCompleted: boolean, subItemId?: string | null) => Promise<Evaluation | null>;
  updateTopicTreeEvaluation: (skillId: string, topic: Topic, isCompleted: boolean) => Promise<void>;
}

export const EvaluationContext = createContext<EvaluationContextType>({} as EvaluationContextType);